import { c as _c } from "react/compiler-runtime";
import { Trans, useTranslation } from 'react-i18next';
import React from 'react';
import Floating from '@/sections/Floating';
import { Link } from '@/components/links';
import { LINKS } from '@/constants/links';
import { useRouter } from 'next/router';
import { FILES } from '@/constants/files';
import { CHRISTMAS_YEAR } from '@/constants/christmas';
export function HowItWorks() {
  const $ = _c(62);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["xmas"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation(t0);
  const {
    locale
  } = useRouter();
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <><div className="bgCircle absolute right-0 bottom-0 hidden translate-x-2/3 translate-y-10 lg:block" /><div className="bgCircle absolute top-1/3 left-0 hidden -translate-x-1/4 -translate-y-1/3 rotate-180 lg:block" /></>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Link analyticsParam="howItWorksRegistration" testId="howItWorksRegistration" to={LINKS().registration} />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  let t4;
  if ($[3] !== t) {
    t3 = <Trans t={t} i18nKey="howItWorks.items.1.text">{t2}</Trans>;
    t4 = t("howItWorks.items.1.title");
    $[3] = t;
    $[4] = t3;
    $[5] = t4;
  } else {
    t3 = $[4];
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t) {
    t5 = t("howItWorks.items.1.title");
    $[6] = t;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t5) {
    t6 = {
      alt: t5,
      src: "/images/sections/xmas/cards/cs/1.png"
    };
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t3 || $[11] !== t4 || $[12] !== t6) {
    t7 = {
      anchorKey: "howItWorks.items.1.title",
      content: t3,
      title: t4,
      image: t6,
      variant: "small"
    };
    $[10] = t3;
    $[11] = t4;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t) {
    t8 = t("howItWorks.items.2.text");
    $[14] = t;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t) {
    t9 = t("howItWorks.items.2.title");
    $[16] = t;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t) {
    t10 = t("howItWorks.items.2.title");
    $[18] = t;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== t10) {
    t11 = {
      alt: t10,
      src: "/images/sections/xmas/cards/cs/2.png"
    };
    $[20] = t10;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== t11 || $[23] !== t8 || $[24] !== t9) {
    t12 = {
      anchorKey: "howItWorks.items.2.title",
      content: t8,
      title: t9,
      image: t11,
      imagePosition: "right",
      variant: "small"
    };
    $[22] = t11;
    $[23] = t8;
    $[24] = t9;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = {
      to: CHRISTMAS_YEAR + 1
    };
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = {
      support_link: <Link analyticsParam="howItWorksRegistration" testId="howItWorksRegistration" to={LINKS().registration} />
    };
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  let t16;
  if ($[28] !== t) {
    t15 = <Trans t={t} i18nKey="howItWorks.items.3.text" values={t13} components={t14} />;
    t16 = t("howItWorks.items.3.title");
    $[28] = t;
    $[29] = t15;
    $[30] = t16;
  } else {
    t15 = $[29];
    t16 = $[30];
  }
  let t17;
  if ($[31] !== t) {
    t17 = t("howItWorks.items.3.title");
    $[31] = t;
    $[32] = t17;
  } else {
    t17 = $[32];
  }
  let t18;
  if ($[33] !== t17) {
    t18 = {
      alt: t17,
      src: "/images/sections/xmas/cards/cs/3.png"
    };
    $[33] = t17;
    $[34] = t18;
  } else {
    t18 = $[34];
  }
  let t19;
  if ($[35] !== t15 || $[36] !== t16 || $[37] !== t18) {
    t19 = {
      anchorKey: "howItWorks.items.3.title",
      content: t15,
      title: t16,
      image: t18,
      variant: "small"
    };
    $[35] = t15;
    $[36] = t16;
    $[37] = t18;
    $[38] = t19;
  } else {
    t19 = $[38];
  }
  let t20;
  if ($[39] !== t12 || $[40] !== t19 || $[41] !== t7) {
    t20 = [t7, t12, t19];
    $[39] = t12;
    $[40] = t19;
    $[41] = t7;
    $[42] = t20;
  } else {
    t20 = $[42];
  }
  let t21;
  if ($[43] !== t) {
    t21 = t("howItWorks.title");
    $[43] = t;
    $[44] = t21;
  } else {
    t21 = $[44];
  }
  let t22;
  if ($[45] !== t) {
    t22 = t("howItWorks.cta");
    $[45] = t;
    $[46] = t22;
  } else {
    t22 = $[46];
  }
  let t23;
  if ($[47] !== locale) {
    t23 = LINKS(locale);
    $[47] = locale;
    $[48] = t23;
  } else {
    t23 = $[48];
  }
  let t24;
  if ($[49] !== t22 || $[50] !== t23.registration) {
    t24 = {
      analyticsParam: "howItWorksCta",
      testId: "howItWorksCta",
      text: t22,
      to: t23.registration
    };
    $[49] = t22;
    $[50] = t23.registration;
    $[51] = t24;
  } else {
    t24 = $[51];
  }
  let t25;
  if ($[52] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = FILES();
    $[52] = t25;
  } else {
    t25 = $[52];
  }
  const t26 = t25.xmasConditions;
  let t27;
  if ($[53] !== t) {
    t27 = t("howItWorks.conditions");
    $[53] = t;
    $[54] = t27;
  } else {
    t27 = $[54];
  }
  let t28;
  if ($[55] !== t27) {
    t28 = <div className="mt-4 text-center"><Link to={t26} testId="xmasConditions" target="_blank" analyticsParam="xmasConditions" className="text-white!">{t27}</Link></div>;
    $[55] = t27;
    $[56] = t28;
  } else {
    t28 = $[56];
  }
  let t29;
  if ($[57] !== t20 || $[58] !== t21 || $[59] !== t24 || $[60] !== t28) {
    t29 = <Floating bgCircles={t1} boxes={t20} title={t21} button={t24} footer={t28} />;
    $[57] = t20;
    $[58] = t21;
    $[59] = t24;
    $[60] = t28;
    $[61] = t29;
  } else {
    t29 = $[61];
  }
  return t29;
}